export const NavigationRoutes = {
    home: '/',
    mtReporter: '/planning',
    mtPrebuilt: '/planning',
    scheduling: '/planning/scheduling',
    chooser: '/reportchooser',
    // mediascope: '/data-solutions',
    folderManagement: '/folder-management'
};
